var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"recommended-next"},[_c('div',{staticClass:"recommended-next__container"},[_c('h3',{staticClass:"recommended-next__container__title"},[_vm._v("Recommended next")]),_c('Tile',{attrs:{"learningPath":_vm.nextLearningPath,"nextContent":_vm.nextContent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }